module.exports = {"name":"CollectorPlugin","version":"2.4.7","description":"","repository":{"type":"git","url":"Graylog2/graylog-plugin-collector"},"scripts":{"build":"webpack --bail"},"keywords":["graylog"],"author":"Graylog, Inc. <hello@graylog.com>","license":"GPL-3.0","dependencies":{"immutable":"^3.7.5"},"devDependencies":{"graylog-web-plugin":"file:../graylog2-server/graylog2-web-interface/packages/graylog-web-plugin"}}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 153
// module chunks = 0